import { createFileRoute } from '@tanstack/react-router'
import { RecoveryFlow } from '@/modules/auth/RecoveryFlow'

// /recovery (exacto). Se usa `recovery.index.tsx` en vez de `recovery.tsx` para
// que NO actúe como layout de `/recovery/verify` (que quedaba sin <Outlet/> y
// hacía que /recovery/verify mostrara este formulario en vez de la verificación).
export const Route = createFileRoute('/recovery/')({
  component: RecoveryFlow,
})
